const shipping = {
  'admin.shipping.menus.hetmet': 'Nhà vận chuyển - Quản lý nhà vận chuyển',
  'admin.shipping.menus.breadcrumb.heading': 'Danh sách nhà vận chuyển',
  'admin.shipping.menus.breadcrumb.parent': 'Quản lý nhà vận chuyển',
  'admin.shipping.btn.add': 'Thêm nhà vận chuyển',
  'admin.shipping.noti.create-shipping.success': 'Thêm nhà vận chuyển mới thành công!',
  'admin.shipping.noti.create-shipping.failure': 'Thêm nhà vận chuyển mới không thành công! Vui lòng thử lại sau',
  'admin.shipping.noti.update-shipping.success': 'Cập nhật nhà vận chuyển thành công!',
  'admin.shipping.noti.update-shipping.failure': 'Thêm nhà vận chuyển mới không thành công! Vui lòng thử lại sau',
  'admin.shipping.noti.delete-shipping.success': 'Xoá nhà vận chuyển thành công!',
  'admin.shipping.noti.delete-shipping.failure': 'Thêm nhà vận chuyển mới không thành công! Vui lòng thử lại sau',
  'admin.shipping.column.sort': 'Thứ tự',
  'admin.shipping.column.name': 'Tên',
  'admin.shipping.column.logo': 'Logo',
  'admin.shipping.column.price': 'Phí giao hàng',
  'admin.shipping.column.active': 'Kích hoạt',
  'admin.shipping.modal.delete.title': 'Xác nhận xoá nhà vận chuyển',
  'admin.shipping.modal.delete.description': 'Bạn chắc chắn muốn xoá nhà vận chuyển này?',
  'admin.shipping.error-msg.name': 'Vui lòng nhập tên nhà vận chuyển!',
  'admin.shipping.error-msg.logo': 'Vui lòng chọn logo!',
  'admin.shipping.error-msg.price': 'Vui lòng nhập phí giao hàng!',
  'admin.shipping.modal.action.title.create': 'Thêm nhà vận chuyển mới',
  'admin.shipping.modal.action.title.update': 'Cập nhật nhà vận chuyển',
  'admin.shipping.modal.action.title.details': 'Thông tin nhà vận chuyển',
  'admin.shipping.modal.action.btn.create': 'Thêm mới',
  'admin.shipping.modal.action.btn.update': 'Cập nhật',
  'admin.shipping.modal.action.label.name': 'Tên nhà vận chuyển',
  'admin.shipping.modal.action.label.logo': 'Logo',
  'admin.shipping.modal.action.label.price': 'Phí giao hàng',
  'admin.shipping.modal.action.label.active': 'Kích hoạt',
};

export default {
  ...shipping,
};
